/**
 * DescriptionChoiceContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled description choice container.
 */
const DescriptionChoiceContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: ${160 * Screen.widthRatio}px;
`;

export default DescriptionChoiceContainer;
